import { useEffect } from "react";
import { useAuth } from "./identity-auth0-context";
import LoadingScreen from "../progress/loading-screen";

export const Logout: React.FC = () => {
  const { signoutRedirect, isLoading } = useAuth();

  useEffect(() => {
    signoutRedirect?.();
  }, [signoutRedirect]);

  if (isLoading) {
    return <LoadingScreen />;
  }
  return null;
};

export default Logout;
